import type { AppLocale } from "./dashboard-copy";

export const fullAccessDetailsCopy = {
  en: {
    title: "What full access includes",
    functionality: "Functionality",
    fullAccess: "Full access",
    duration: "7 consecutive days",
    close: "Close",
    rows: [
      ["AI-generated CV conforming to Canadian standards", "AI reorganizes your CV"],
      ["Manual editing", "Unlimited for 7 days"],
      ["Visual overview of the CV", "PDF HD proper without watermark"],
      ["AI regenerations", "Up to 5 regenerations included"],
      ["NOC Code and Title", "Accessible professional code and title"],
      ["AI translation", "1 complete translation offered"],
      ["Bilingual CV Pack", "1 French CV + 1 English CV included"],
      ["PDF Download", "Instant & unlimited download"],
      ["Duration of access", "Access & modifications for 7 days"],
    ],
  },
  fr: {
    title: "Ce que comprend l’accès complet",
    functionality: "Fonctionnalité",
    fullAccess: "Accès complet",
    duration: "7 jours consécutifs",
    close: "Fermer",
    rows: [
      ["CV généré par l’IA selon les normes canadiennes", "L’IA réorganise votre CV"],
      ["Modification manuelle", "Illimitée pendant 7 jours"],
      ["Aperçu visuel du CV", "PDF HD propre sans filigrane"],
      ["Régénérations par l’IA", "Jusqu’à 5 régénérations incluses"],
      ["Code et titre CNP", "Code et titre professionnels officiels accessibles"],
      ["Traduction par l’IA", "1 traduction complète incluse"],
      ["Ensemble de CV bilingue", "1 CV français + 1 CV anglais inclus"],
      ["Téléchargement PDF", "Téléchargements instantanés et illimités"],
      ["Durée d’accès", "Accès et modifications pendant 7 jours"],
    ],
  },
} as const satisfies Record<AppLocale, object>;
